/**
 * TanStack Query client (mirrors web/src/app/queryClient.ts).
 *
 * Intentional defaults: modest staleTime, bounded retries for transient
 * network/5xx only (auth and validation errors never retry), and window-focus
 * refetch disabled by default (enabled per-query where it adds value).
 */
import { QueryClient } from '@tanstack/react-query';
import { defaultRetry } from '@/api/client';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Modest staleness: admin lookups are fresh for ~30s.
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: defaultRetry,
        refetchOnWindowFocus: false,
        refetchOnReconnect: 'always',
      },
      mutations: {
        // Never retry mutations automatically; admin mutations are
        // user-visible side effects with an audit trail.
        retry: false,
      },
    },
  });
}
